import { supabase } from "../lib/supabaseClient";

type SearchEventType = "search" | "click";

export function logSearchActivity(params: {
  query: string;
  eventType: SearchEventType;
  resultCount?: number;
  clickedProductId?: number;
  userId?: string;
}): void {
  supabase
    .rpc("log_search_activity", {
      p_query: params.query,
      p_event_type: params.eventType,
      p_result_count: params.resultCount ?? 0,
      p_clicked_product_id: params.clickedProductId ?? null,
      p_user_id: params.userId ?? null,
      p_is_category: false,
    })
    .then(
      () => {},
      () => {}
    );
}
